// extracted by mini-css-extract-plugin
export default {"wrapper":"_e014b13e","image":"_31b3a04a","placeholder":"_d5f56f8e","moduleWrapper":"_24616de4","module":"_ba4e1737","title":"_9076224d","subtitle":"_97a5d1c9","button":"_40620f7b"};